export default __webpack_public_path__ + "img/3e9e53cf387d9757bcdf5ad48511536f.png";